var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'cursor-not-allowed': _vm.disabled }},[_c('el-tag',_vm._g(_vm._b({staticClass:"font-semibold",class:[
            { 'pointer-events-none opacity-50': _vm.disabled },
            { 'cursor-pointer hover:opacity-90': _vm.isPointer },
            _vm.coloredTypes, _vm.customClass
        ],attrs:{"size":"small"}},'el-tag',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }